<template>
  <div>
    <div
      v-show="show"
      ref="wrapRef"
      class="group-drop-tran over-hidden"
      @transitionend="onTransitionEnd"
    >
      <div ref="unfoldRef">
        <div div v-for="item in data" :key="item.id" :class="item.projectIntegrateType === 1 ? 'set-group': 'sub-content mb12'">
            <Subproject-group v-if="item.projectIntegrateType === 1" class="mb12" :title="item.name"  :num="item.project4IntegrateInfo.length">
              <Subproject-item v-for="sItem in item.project4IntegrateInfo"
                              :key="sItem.id"
                              :data="sItem"
              />
            </Subproject-group>
            <Subproject-item v-else :data="item" />
          </div>
      </div>
    </div>
    <div class=" more font-size-14 ">
      <div
        class="inline-center cursor-p text-no-select"
        @click="resizeHeight"
      >
        <span>
          {{ $t('biz_pc_expand_more' /** 展开更多 */) }}
        </span>
        <yxt-svg
          class="ml6"
          :icon-class="checkStatus ? 'arrow_down' : 'arrow_up'"
          width="12px"
          height="12px"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SubprojectGroup from './subproject-group.vue';
import SubprojectItem from './subproject-item.vue';
import foldMixins from './index';

export default {
  mixins: [foldMixins],
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  components: {
    SubprojectGroup,
    SubprojectItem
  }
};
</script>
